/* Copyright (c) 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  PlanSortInput,
  useGetPlanNamesQuery,
  PlansFilterInput,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort?: PlanSortInput;
  filter?: PlansFilterInput;
};

export function useGetPlanNames({ page, limit, sort, filter }: Props) {
  const { data, loading, error, refetch } = useGetPlanNamesQuery({
    variables: { page: Number(page), limit: Number(limit), sort, filter },
  });

  const count = data?.plans?.pageInfo?.count ?? 0;

  return {
    data: data?.plans.result ?? [],
    loading,
    error,
    count,
    refetch,
  } as const;
}
